import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { CAMPAIGN_CONFIG_FLAG_PREFIX, } from "../shared/campaign-config.types.js";
let logger;
const knownConfigs = new Map();
const maxImpressionsCeiling = 20;
function isObject(candidate) {
    return typeof candidate === "object" && candidate !== null;
}
function isMaxImpressions(candidate) {
    return (Number.isInteger(candidate) &&
        candidate >= 1 &&
        candidate <= maxImpressionsCeiling);
}
function parseCampaignConfig(entry, ipmId) {
    if (!isObject(entry)) {
        logger.warn("[opd-persistence-experiment]: Campaign config is not an object", ipmId);
        return null;
    }
    const config = {};
    if (typeof entry.ignoreCooldown !== "undefined") {
        if (typeof entry.ignoreCooldown !== "boolean") {
            logger.warn("[opd-persistence-experiment]: Invalid ignoreCooldown", ipmId);
            return null;
        }
        config.ignoreCooldown = entry.ignoreCooldown;
    }
    if (typeof entry.maxImpressions !== "undefined") {
        if (!isMaxImpressions(entry.maxImpressions)) {
            logger.warn("[opd-persistence-experiment]: Invalid maxImpressions", ipmId);
            return null;
        }
        config.maxImpressions = entry.maxImpressions;
    }
    if (Object.keys(config).length === 0) {
        logger.warn("[opd-persistence-experiment]: Campaign config has no known fields", ipmId);
        return null;
    }
    return config;
}
async function initializeConfigs() {
    const flags = await ewe.experiments.getFlags();
    knownConfigs.clear();
    for (const name of Object.keys(flags).sort()) {
        if (!name.startsWith(CAMPAIGN_CONFIG_FLAG_PREFIX)) {
            continue;
        }
        const value = flags[name];
        if (!isObject(value)) {
            logger.warn("[opd-persistence-experiment]: Campaign config flag is not an object", name);
            continue;
        }
        for (const [ipmId, entry] of Object.entries(value)) {
            if (knownConfigs.has(ipmId)) {
                continue;
            }
            const config = parseCampaignConfig(entry, ipmId);
            if (config !== null) {
                knownConfigs.set(ipmId, config);
            }
        }
    }
    logger.debug("[opd-persistence-experiment]: Known campaign configs", knownConfigs);
}
export function getCampaignConfig(ipmId) {
    var _a;
    if (typeof ipmId !== "string") {
        return null;
    }
    return (_a = knownConfigs.get(ipmId)) !== null && _a !== void 0 ? _a : null;
}
export async function start(hostLogger) {
    logger = hostLogger;
    await initializeConfigs();
    ewe.experiments.onChanged.addListener(() => {
        void initializeConfigs();
    });
}
